import { useState } from "react"
import { Link } from "react-router-dom"
import { Button } from "./Button"
import { Menu, X } from "lucide-react"
import "../components/MobileMenu.css";

export default function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false)

  const closeMenu = () => setIsOpen(false)

  return (
    <div className="mobile-menu-container">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="mobile-menu-toggle"
        aria-label="Toggle menu"
      >
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {isOpen && (
        <div className="mobile-menu-dropdown">
          <nav className="mobile-nav">
            <a href="/#products" className="mobile-nav-link" onClick={closeMenu}>
              Products
            </a>
            <a
              href="/#innovation"
              className="mobile-nav-link"
              onClick={closeMenu}
            >
              Innovation
            </a>
            <Link to="/gallery" className="mobile-nav-link" onClick={closeMenu}>
              Gallery
            </Link>
            <Link to="/about" className="mobile-nav-link" onClick={closeMenu}>
              About
            </Link>
            <Link to="/contact" className="mobile-nav-link" onClick={closeMenu}>
              Contact
            </Link>
            <div className="mobile-auth-actions">
              <Button variant="outline" className="mobile-btn-signin">
                Sign In
              </Button>
              <Button className="mobile-btn-start">Get Started</Button>
            </div>
          </nav>
        </div>
      )}
    </div>
  )
}

